import types from '../types';

export const initialState = [];

export default function vendorPricingAuditReducer(state = initialState, action) {
    switch (action.type) {
        case types.GET_VENDOR_PRICING_AUDIT:
            const vendorPricingAudit = action.payload;
            if(action.payload !== null) {
                return vendorPricingAudit;
            } else return state;
        default:
            return state;
    }
};
